export default "__VITE_ASSET__DNbnee$A__"